(() => {
  const marker = document.querySelector('[data-ar30-page]');
  const hero = marker ? document.querySelector('main .banner') : null;
  if (!hero) return;
  document.body.classList.add('ar30-review-page');
  const drawer = document.querySelector('cart-drawer');
  const clarifyCart = () => {
    drawer?.querySelectorAll('.aurala-cart__gst, .aurala-cart__social-head, .aurala-cart__card--green').forEach(node => node.remove());
    const card = drawer?.querySelector('.aurala-cart__card--tan');
    if (!card || card.dataset.ar30Returns === 'true') return;
    const title = card.querySelector('.aurala-cart__card-title');
    const detail = card.querySelector('.aurala-cart__card-sub');
    if (!title || !detail) return;
    title.textContent = '60-day returns from delivery';
    detail.textContent = 'Keep the oil. For an applicable kit refund, return the diffuser in reusable condition. ';
    const terms = document.createElement('a');
    terms.href = '/pages/returns-refunds-policy';
    terms.textContent = 'See terms.';
    detail.append(terms);
    card.dataset.ar30Returns = 'true';
  };
  if (drawer) {
    clarifyCart();
    new MutationObserver(clarifyCart).observe(drawer, {childList:true, subtree:true});
  }
  const heroAction = hero.querySelector('a[href="#ar30-choose"]');
  const choices = document.querySelector('#ar30-choose .aurala-picker__grid');
  const sticky = document.querySelector('.ar30-sticky');
  const close = document.querySelector('.ar30-close');
  const faq = document.querySelector('.ar30-faq');
  if (!heroAction || !choices || !sticky) return;
  const updateSticky = () => {
    const viewport = window.innerHeight;
    const intersects = el => {const r=el.getBoundingClientRect(); return r.bottom>0 && r.top<viewport;};
    sticky.hidden = heroAction.getBoundingClientRect().bottom>0 || intersects(choices) || (close && intersects(close)) || (faq && intersects(faq)) || drawer?.classList.contains('active') || document.body.classList.contains('overflow-hidden');
    sticky.style.bottom = '0px';
  };
  let pending=false;
  const schedule = () => {if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;updateSticky();});};
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule);
  new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class']});
  if(drawer)new MutationObserver(schedule).observe(drawer,{attributes:true,attributeFilter:['class']});
  updateSticky();
})();
